export default "<p>\n  phone-number-element works!\n</p>\n";